import { Box, Container, Grid2 } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { String } from "../../constants/Strings";
import { ACRStyledButtonCurrentPortfolio } from "../../style/styleComponents/StyledCurrentPoerfolio";
import ACRButton from "../../commanComponents/ACRButton";
import { CurrentPortfolioCard } from "./CurrentPortfolioCard";
import { LinearProgressBar } from "../../commanComponents/LinearProgressBar";
import { PageTitle } from "../../commanComponents/PageTitle";
import { useNavigate } from "react-router-dom";
import { useFinacialPortfolioService } from "../../api/apiEndpoints/FinancialPortfolio";
import { AuthContext } from "../../Hooks/context/AuthContext";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";

const CurrentPortfolio = () => {
  const [portfolioData, setPortfolioData] = useState([]);
  const [, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const { authTokens } = useContext(AuthContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const { userId } = authTokens;

  const { fetchFinancialPortfolioDetails } = useFinacialPortfolioService();

  useEffect(() => {
    const fetchPortfolioData = async () => {
      try {
        const response = await fetchFinancialPortfolioDetails({
          userId: userId,
        });

        if (response.httpCode === 200) {
          setPortfolioData(response.response.portfolios);
        } else {
          throw new Error(String.CurrentPortfolio.failedToFetchData);
        }
      } catch (error) {
        setErrorMessage(
          error.message || String.CurrentPortfolio.failedToFetchData
        );
      }
    };

    fetchPortfolioData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onHandleClick = () => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioContinue, verifyData.customerId);
    navigate(String.navigations.monthlyincomeintroduction);
  };

  return (
    <Container>
      <PageTitle PageTitle={String.CurrentPortfolio.CurrentPortfolioTitle} />
      <LinearProgressBar
        stepNumber={1}
        progressNumber={18}
        progress={18}
        dragMessage={String.CurrentPortfolio.dragMessage}
      />
      <Box
        sx={{
          mt: "10px",
          height: "500px",
          overflowY: "auto",
        }}
      >
        <Grid2 spacing={2}>
          {portfolioData.map((plan, index) => (
            <Grid2 item key={index}>
              <CurrentPortfolioCard
                key={index}
                issueDate={plan.issueDate}
                modelPremium={plan.modelPremium}
                ownerClientName={plan.ownerClientName}
                policyTerm={plan.policyTerm}
                premiumReceivedTillDate={plan.premiumReceivedTillDate}
                sumAssured={plan.sumAssured}
              ></CurrentPortfolioCard>
            </Grid2>
          ))}
        </Grid2>
      </Box>
      <Box component={"footer"} sx={{ mt: "38px", textAlign: "center" }}>
        <ACRButton
          label={String.continue}
          style={ACRStyledButtonCurrentPortfolio}
          onClickButton={onHandleClick}
        ></ACRButton>
      </Box>
    </Container>
  );
};

export default CurrentPortfolio;
